import axios from 'axios'
import qs from 'qs'
import rootApi from '@/rootUrl'
const root = rootApi //接口API
// const root = "https://stuapi.kidcastle.cn" //接口API
const url = {
  Login:root+"/Base/Login",//登陆页->账户密码登陆
  MisLogin:root+"/Base/MisLogin",//登陆页->手机获取登陆信息
  getAuthcode:root+"/Base/getAuthcode",//登陆页->手机获取登陆信息
  forgetPass:root+"/Base/forgetPass",//忘记密码->找回密码
  isTrueofForgetCode:root+"/Base/isTrueofForgetCode",//忘记密码->验证验证码
  getForgetPassCode:root+"/Base/getForgetPassCode",//忘记密码获取验证码码
  getAllStudents:root+"/Student/getAllStudents",//个人中心 获取全部孩子信息
}
const loginStore =  {
  // 登陆页->账户密码登陆
  Login(params){
    return axios.get(url.Login,{ params })
  },
  // 登陆页->手机获取登陆信息
  MisLogin(params){
    return axios.get(url.MisLogin,{ params })
  },
   // 登陆页->手机获取验证码
   getAuthcode(params){
    return axios.get(url.getAuthcode,{ params })
  },
  // 忘记密码->找回密码
  forgetPass(params) {
    return axios.post(url.forgetPass, qs.stringify(params))
  },
  // 忘记密码->验证验证
  isTrueofForgetCode(params) {
    return axios.post(url.isTrueofForgetCode, qs.stringify(params))
  },
  // 忘记密码获取验证码
  getForgetPassCode(params){
    return axios.get(url.getForgetPassCode,{ params })
  },
   // 个人中心 获取全部孩子信息
   getAllStudents(params){
    return axios.get(url.getAllStudents,{ params })
  },
}

export default loginStore;